import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import WhatIsSection from "./components/WhatIsSection";
import CategoryGrid from "./components/CategoryGrid";
import ArticlesGrid from "./components/ArticlesGrid";
import ArticlePromo from "./components/ArticlePromo";
import BuyingGuide from "./components/BuyingGuide";
import ReviewSection from "./components/ReviewSection";
import ShippingSection from "./components/ShippingSection";
import CouponSection from "./components/CouponSection";
import SafetySection from "./components/SafetySection";
import Footer from "./components/Footer";
import JsonLd from "@/components/base/JsonLd";

const SITE_URL = "https://sugargoosheet.my";
const SITE_NAME = "Sugargoo Spreadsheet";
const SITE_DESCRIPTION = "Discover the ultimate Sugargoo Spreadsheet with updated product finds, QC guides, shipping costs, coupons, warehouse information and expert buying tips. Your #1 Sugargoo resource hub.";
const LOGO_URL = "https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/1fc56da0b352904925ac780066826afe.jpeg";

const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": SITE_NAME,
  "url": SITE_URL,
  "logo": LOGO_URL,
  "description": SITE_DESCRIPTION,
  "sameAs": [
    "https://kaspreadsheet.com"
  ]
};

const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "name": SITE_NAME,
  "url": SITE_URL,
  "description": SITE_DESCRIPTION,
  "potentialAction": {
    "@type": "SearchAction",
    "target": {
      "@type": "EntryPoint",
      "urlTemplate": "https://kaspreadsheet.com/search?q={search_term_string}"
    },
    "query-input": "required name=search_term_string"
  }
};

export default function Home() {
  return (
    <>
      <JsonLd data={organizationSchema} />
      <JsonLd data={websiteSchema} />
      <Navbar />
      <main>
        <HeroSection />
        <WhatIsSection />
        <CategoryGrid />
        <ArticlesGrid />
        <ArticlePromo />
        <BuyingGuide />
        <ReviewSection />
        <ShippingSection />
        <CouponSection />
        <SafetySection />
      </main>
      <Footer />
    </>
  );
}